module.exports = __webpack_public_path__ + "static/media/python.6dd7bc34.png";